import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "order-view pt-2 pb-2" }
const _hoisted_2 = { class: "w-100 d-flex a-i-center j-content-start direction-column" }
const _hoisted_3 = { class: "order-image" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "w-100 d-flex j-content-start a-i-center direction-column" }
const _hoisted_6 = { class: "w-100 text-motserrat-18 mb-2" }
const _hoisted_7 = { class: "w-100 d-flex j-content-start a-i-center direction-column order-data-wrapper" }
const _hoisted_8 = { class: "w-100 text-hyphes pr-1" }
const _hoisted_9 = {
  key: 0,
  class: "w-100 text-hyphes text-start"
}
const _hoisted_10 = ["checked"]
const _hoisted_11 = {
  key: 1,
  class: "w-100 text-hyphes text-start"
}
const _hoisted_12 = { class: "order-view pt-2 pb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "order-image skeleton-loading-line" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-100 text-motserrat-18 mb-2" }, " Loading ... "),
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 d-flex j-content-start a-i-center direction-column loading-tbr skeleton-loading-line" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import { IUseFetchDetailError } from "../../../hook/fetch/interface";
import { CARS, IResultSearchStore, TRUCK } from "@/store/modules/Search/type";
import { useFetch } from "../../../hook/fetch/fetch";
import { ref, onBeforeMount, computed } from "vue";
import { useRoute } from "vue-router";
import { store } from "@/store";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderViewTbr',
  setup(__props) {

const route = useRoute();
const img = ref<string>();
const loading = ref(true);
const full_name = ref<string>();
const ordersDetails = ref<TRUCK>({} as TRUCK);

const id = route.params.id;
const orderId = id ?? null;

onBeforeMount(async () => {
  if (!orderId) return;
  const token = ref(computed<string>(() => store.getters.accessTokenGet));
  const { isLoading, isError, errorMessage, data } = await useFetch<
    IResultSearchStore<CARS>,
    IUseFetchDetailError
  >(
    process.env.VUE_APP_SERVER +
      `api/search/?classificator=tbr&product__id=${orderId}`,
    "GET",
    !!token.value
  );

  if (Object.keys(data?.value?.results[0]?.product_tyre || {}).length > 0) {
    let key: keyof CARS;
    for (key in data?.value?.results[0].product_tyre) {
      console.log(key);
      if (key === "photo_path")
        img.value =
          process.env.VUE_APP_SERVER +
          data?.value?.results[0].product_tyre.photo_path;
      if (
        (data?.value?.results[0].product_tyre[key] ||
          (key === "runflat" &&
            typeof data?.value?.results[0].product_tyre[key] === "boolean")) &&
        typeof data?.value?.results[0].product_tyre[key] !== "number" &&
        data?.value?.results[0].product_tyre[key] !== "0" &&
        data?.value?.results[0].product_tyre[key] !== "0.00" &&
        data?.value?.results[0].product_tyre[key] !== "NULL" &&
        key !== "last_date_time_modify" &&
        key !== "photo_path" &&
        key !== "updated"
      ) {
        (ordersDetails.value as any)[key] =
          data?.value?.results[0].product_tyre[key];
      }
    }

    window.resizeTo(
      800,
      Object.keys(data?.value?.results[0].product_tyre || {}).length * 30
    );

    const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));

    SeoTitle("Tyre point: " + data?.value?.results[0].product_tyre.full_name);
    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  }

  loading.value = isLoading.value;

  console.log(isLoading.value, isError.value, errorMessage.value, data.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "img-order",
            src: img.value || require('@/assets/' + 'no_image.jpg'),
            alt: img.value || 'not found'
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("article", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(full_name.value), 1),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordersDetails.value, (data, keyData, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w-100 a-i-center j-content-center order-table-info text-motserrat-14 wrapper-info-order",
              key: keyData + '_' + i
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(keyData.replaceAll("_", " "))), 1),
              (
              data.toString().toLocaleLowerCase() === 'true' ||
              data.toString().toLocaleLowerCase() === 'false'
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: true,
                      checked: data.toString().toLocaleLowerCase() === 'true'
                    }, null, 8, _hoisted_10)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(typeof data === "string"
              ? data.replaceAll("_", " ").toLocaleLowerCase()
              : data || "no info"), 1))
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_12, _hoisted_15, 512), [
      [_vShow, loading.value]
    ])
  ], 64))
}
}

})